import React from 'react';

export const TwitterIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8203 0.212402C12.0132 0.212402 0.820312 11.4053 0.820312 25.2124C0.820312 39.0195 12.0132 50.2124 25.8203 50.2124C39.6274 50.2124 50.8203 39.0195 50.8203 25.2124C50.8203 11.4053 39.6274 0.212402 25.8203 0.212402ZM34.6329 21.2857C35.5897 21.1699 36.5003 20.9105 37.3489 20.5281C36.7164 21.4923 35.9124 22.3392 34.9831 23.0133L34.999 23.6361C34.999 29.9927 30.2427 37.3223 21.5414 37.3223C18.8701 37.3223 16.3846 36.5251 14.291 35.158C14.6613 35.2005 15.0374 35.2239 15.4192 35.2239C17.6352 35.2239 19.6755 34.4575 21.2936 33.168C19.2245 33.1299 17.4781 31.7393 16.8759 29.8271C17.1655 29.8857 17.4609 29.9165 17.7663 29.9165C18.1986 29.9165 18.6164 29.8564 19.0127 29.7479C16.85 29.3054 15.2189 27.3609 15.2189 25.031V24.9709C15.8572 25.3314 16.5863 25.5483 17.3615 25.5747C16.0935 24.7131 15.2578 23.2404 15.2578 21.5714C15.2578 20.6892 15.4898 19.8628 15.8975 19.1536C18.2303 22.0638 21.7157 23.9789 25.6463 24.1797C25.5656 23.828 25.5238 23.4602 25.5238 23.0836C25.5238 20.4285 27.6419 18.2744 30.2541 18.2744C31.6158 18.2744 32.8434 18.8576 33.7064 19.794C34.7842 19.5771 35.7957 19.177 36.7121 18.6261C36.3576 19.7471 35.6098 20.6907 34.6329 21.2857Z"
      fill="#F1F2F3"
      fillOpacity="0.31"
    />
  </svg>
);
